module.exports = __webpack_public_path__ + "img/arcos-c-img-2.12ea898a.jpg";